module.exports = __webpack_public_path__ + "img/web-development.247693a1.png";